export function getOnClickHandlerProps(props, ref) {
    var propsToUse = {
        onClick: props.onClick,
        onClickCapture: props.onClickCapture,
        onContextMenu: props.onContextMenu,
        onContextMenuCapture: props.onContextMenuCapture,
        onDoubleClick: props.onDoubleClick,
        onDoubleClickCapture: props.onDoubleClickCapture,
        onMouseDown: props.onMouseDown,
        onMouseDownCapture: props.onMouseDownCapture,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave,
        onMouseMove: props.onMouseMove,
        onMouseMoveCapture: props.onMouseMoveCapture,
        onMouseOut: props.onMouseOut,
        onMouseOutCapture: props.onMouseOutCapture,
        onMouseOver: props.onMouseOver,
        onMouseOverCapture: props.onMouseOverCapture,
        onMouseUp: props.onMouseUp,
        onMouseUpCapture: props.onMouseUpCapture,
        onAuxClick: props.onAuxClick,
        onAuxClickCapture: props.onAuxClickCapture,
        onDrag: props.onDrag,
        onDragCapture: props.onDragCapture,
        onDragEnd: props.onDragEnd,
        onDragEndCapture: props.onDragEndCapture,
        onDragEnter: props.onDragEnter,
        onDragEnterCapture: props.onDragEnterCapture,
        onDragExit: props.onDragExit,
        onDragExitCapture: props.onDragExitCapture,
        onDragLeave: props.onDragLeave,
        onDragLeaveCapture: props.onDragLeaveCapture,
        onDragOver: props.onDragOver,
        onDragOverCapture: props.onDragOverCapture,
        onDragStart: props.onDragStart,
        onDragStartCapture: props.onDragStartCapture,
        onDrop: props.onDrop,
        onDropCapture: props.onDropCapture,
    };
    if (props.refOnClick) {
        var propOnClick_1 = props.onClick;
        propsToUse.onClick = function (e) { propOnClick_1 && propOnClick_1(e); props.refOnClick(ref.current, e); };
    }
    if (props.refOnDoubleClick) {
        var propOnDoubleClick_1 = props.onDoubleClick;
        propsToUse.onDoubleClick = function (e) { propOnDoubleClick_1 && propOnDoubleClick_1(e); props.refOnDoubleClick(ref.current, e); };
    }
    return {
        classes: {},
        props: propsToUse,
        styles: {},
        variables: {}
    };
}
